/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerGetTransferLogsQueryResponse, TransfersControllerGetTransferLogsPathParams, TransfersControllerGetTransferLogsQueryParams, TransfersControllerGetTransferLogs401, TransfersControllerGetTransferLogs403 } from "../../models/transfersController/TransfersControllerGetTransferLogs";

function getTransfersControllerGetTransferLogsUrl(id: TransfersControllerGetTransferLogsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/transfers/${id}/logs` as const }  
  return res
}

/**
 * @summary Get transfer run logs
 * {@link /api/v1/transfers/:id/logs}
 */
export async function transfersControllerGetTransferLogs(id: TransfersControllerGetTransferLogsPathParams["id"], params?: TransfersControllerGetTransferLogsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransfersControllerGetTransferLogsQueryResponse, ResponseErrorConfig<TransfersControllerGetTransferLogs401 | TransfersControllerGetTransferLogs403>, unknown>({ method : "GET", url : getTransfersControllerGetTransferLogsUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}